


























































import { Component, Vue } from 'vue-property-decorator';
import Searchbox from './Searchbox.vue';
import Jobseeker from './Jobseeker.vue';
import Myreferrals from './Myreferrals.vue';
import { vxm } from '@/store.vuex';
import { JobsStore } from '@/models/jobs/jobs.vuex';

@Component({
  name: 'ReferralListing',
  components: {
    Searchbox,
    Jobseeker,
    Myreferrals
  }
})

export default class ReferralListing extends Vue {

    private jobStore: JobsStore = new JobsStore();

    get isLoggedIn(): boolean {
      return vxm.users.isLoggedIn;
    }

}

